import * as types from './mutation-types'
import { setStorage } from '@/utils/localStorage'
export const WeatherDataTypeKey = 'trace-weatherDataType'

const mutations = {
  [types.SET_BASEINFO] (state, baseInfo) {
    state.baseInfo = baseInfo
  },
  [types.SET_PRODUCTIONINFO] (state, productionInfo) {
    state.productionInfo = productionInfo
  },
  [types.SET_SHARE_BASEINFO] (state, baseInfo) {
    state.shareBaseInfo = baseInfo
  },
  [types.SET_WEATHER_DATA_TYPE] (state, weatherDataType) {
    state.weatherDataType = weatherDataType
    setStorage(WeatherDataTypeKey, weatherDataType)
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js